import React, { useState, useEffect } from 'react';
import Oglas from './Oglas';
import styles from './OglasiList.module.css';
import { BASE_URL_OGLASI } from '../util/constants';

const OglasiList = (props) => {
  const [oglasi, setOglasi] = useState([]);

  useEffect(() => {
    fetch(BASE_URL_OGLASI + props.match.params.id)
      .then(response => response.json())
      .then(data => setOglasi(data))
      .catch(function (err) {
        console.log('Fetch Error :', err);
      });
  }, [props.match.params.id]);

  return (
    <div>
      {oglasi === undefined || oglasi.length === 0 ? (
          <div className={styles.emptyListContainer}>Nema aktivnih oglasa.</div>
      ) : (
        oglasi.map(oglas => {
          return (
            <Oglas
              naslov={oglas.naslov}
              vrijemeKreiranja={oglas.vrijemeKreiranja}
              sadrzaj={oglas.sadrzaj}
              potpis={oglas.potpis}
              uvod={oglas.uvod}
              oglasPrilozi={oglas.oglasPrilozi}
              id={oglas.id}
              key={oglas.id} />
          );
        })
      )}
    </div>
  );
}

export default OglasiList;